<template>
  <div class="panel panel-default panel-dashboard tw-mb-0">
    <LoadingSpinner v-if="revenue === null"/>

    <div v-else class="panel-body text-center">
      <div class="row">
        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            <IndexNumber :value="index"/>
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Index
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ revenue | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Revenue
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 28px; margin-bottom: 0">
            {{ publication.attributes.target | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Target
          </p>
        </div>

        <div class="col-xs-6">
          <p style="font-size: 28px; margin-bottom: 0">
            <span v-if="units">
              {{ revenue / units | price }}
            </span>

            <span v-else>
              N/A
            </span>
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Price Per Unit
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import IndexNumber from "../../../../../../components/Numbers/IndexNumber.vue";

export default {
  components: {IndexNumber, LoadingSpinner},

  props: {
    publication: {
      required: true
    }
  },

  data() {
    return {
      revenue: null,
      units: null
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    index() {
      if(!this.publication.attributes.target) {
        return null
      }

      return this.revenue / this.publication.attributes.target * 100
    }
  },

  methods: {
    load() {
      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'publication_ad_value_after_costs'},
          {name: 'publication_ad_units'},
        ],
        filters: [
          {dimension: 'publication_id', operator: '=', value: this.publication.id},
        ]
      })
          .then(response => {
            this.revenue = response.data.data[0].publication_ad_value_after_costs

            this.units = response.data.data[0].publication_ad_units
          })
    }
  }
}
</script>
